  
<app-modal-header [headerTitle]="headerTitle" (languageSelected)="setSelectedLanguage($event)"></app-modal-header>
 
<div class="globalContainer" *ngIf="item != null && listsLoaded == true">

    <div  style="border-bottom:1px solid gray">All Languages</div>

    <div class="form-group row">

        <div class="col-6">

            <div class="  row">

            <div class="col-6">

                <div class="form-material">
                    <input type="number" matInput [(ngModel)]="item.Chapter"/>
                    <label for="">Chapter</label>
                  </div> 
  
                <div class="form-material">
                    <input type="number" matInput [(ngModel)]="item.Verse"/>
                    <label for="">Verse</label>
                  </div> 
  
                  <div class="form-material">
                      <input type="number" matInput [(ngModel)]="item.Part"/>
                      <label for="">Part</label>
                    </div> 

                    <div class="form-material">
                      <input type="number" matInput [(ngModel)]="item.Line"/>
                      <label for="">Line</label>
                    </div> 
                    <div class="form-material">
                        <input type="text" matInput [(ngModel)]="item.Letter"/>
                        <label for="">Letter</label>
                      </div> 

              </div>

              <div class="col-6">
    
                  <div class="form-material">
    
                      <select [ngModel]="item.LectionarySource?.Id" (ngModelChange)="item.LectionarySource = setModelValue($event, item.LectionarySource)">
                          <option *ngFor="let section of lectionarySources" [ngValue]="section.Id">
                              {{section.Name}}
                          </option>
                        </select>
      
                      <label for="">Lectionary Source</label>
      
                  </div>

                  <div class="form-material">
                      <input type="number" matInput [(ngModel)]="item.Page"/>
                      <label for="">Page</label>
                  </div> 

                  <div class="form-material">
                      <input type="number" matInput [(ngModel)]="item.Book"/>
                      <label for="">Book</label>
                    </div> 

                  <div class="form-material">
                      <input type="number" matInput [(ngModel)]="item.Day"/>
                      <label for="">Day</label>
                    </div> 




              </div>
        
            </div>


        </div>

        <div class="col-6"> 
          <div class=""> 
              <div class="form-material">
                  <input type="text" matInput [(ngModel)]="item.ProofedByName" readonly/>
                  <label for="">Proofed</label>
              </div>
          </div>

          <div class=""> 
              <div class="form-material">
                <input type="checkbox"  [(ngModel)]="item.IsSpaceAfter">
                  <label for="">Is Space After</label>
              </div>
          </div>
                

          <div class=""> 
              <div class="form-material">
                  <textarea matInput class="txtComments" [(ngModel)]="item.Comments"></textarea>
                  <label for="">Comments</label>
              </div>
          </div>
        </div>
 
    </div>
 
    <div class="row">
      <div class="col-12">

        <div *ngIf="CurrentLocalizedData() != null" style="border-bottom:1px solid gray">
          {{currentLanguage.Name}}
        </div>
        
      </div>
    </div>

      <span *ngIf="CurrentLocalizedData() != null">
        <div class="row">
            
          <div class="col-6">
              <div class="form-material">
                    
                      <input type="text" matInput [(ngModel)]="CurrentLocalizedData().AlternateName"/>
                      <label for="">Sub Name</label> 
              </div>
          </div>

          <div class="col-6"> 
                <div class="form-material">
                    <input type="text" matInput [(ngModel)]="CurrentLocalizedData().Office"/>
                    <label for="">Office</label>
                </div> 
 
          </div>

          <div class="col-12">
              <div class="form-material htmlEditorContainer">
                  <app-lectionary-item-html-editor [textAreaValue]="CurrentLocalizedData().Html" (valueChanged)="htmlChanged($event)"></app-lectionary-item-html-editor>
              </div>
          </div>

        </div>
      </span> 



      <div class="row" style="margin-top:10px">

          <div class="col-sm-4">
              <app-display-matching-pronunciatons [psalterId]="item.Id"></app-display-matching-pronunciatons>
          </div> 
      
          <div class="col-sm-8">
      
              <div mat-dialog-actions class="float-right">
                  <button mat-button (click)="cancel()" class="btn btn-sm btn-outline-secondary" style="margin-right:10px">Cancel</button>
                  <button mat-button (click)="save(false)" class="btn btn-sm btn-outline-primary" style="margin-right:10px">{{saveButtonText}}</button>
                  <button mat-button (click)="save(true)" class="btn btn-sm btn-outline-primary">Save and Proof</button>
              </div>
      
          </div>
      </div>



  </div>

 

 